import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import StripePaymentForm from './StripePaymentForm';

// Initialize Stripe outside of the component to avoid recreating the Stripe object on every render
// Replace with your actual publishable key from environment variables
const stripePromise = loadStripe('pk_live_51IP7A0DC5QxjLpwCCjjcoJ2U7R9joIEIXrZ1DIltyP28Lbp8VPfsq9CJ9EMsQ4LP9aLmMTjAgUaUqyJftQCtciD700cRxHQyWJ');

const StripeProvider = (props) => {
  return (
    <Elements stripe={stripePromise}>
      <StripePaymentForm {...props} />
    </Elements>
  );
};

export default StripeProvider;